import React, { useEffect, useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import CustomTable from "../../components/DataTable/CustomTable";
import { TableBody, TableCell, TableRow } from "@material-ui/core";
import { getLeavePlans } from "../../services/util";
import { useHistory } from "react-router-dom";

//To download table as Excel
import TableToExcel from "@linways/table-to-excel";

//Images
import downloadBtn from "../../assets/Images/excel_down.png";

//CSS
import "../../assets/CSS/DownloadBtn.css";

const headCells = [
  { id: "EmployeeID", title: "Employee ID", disableSorting: false },
  { id: "EmployeeFirstName", title: "Employee Name", disableSorting: false },
  { id: "Project", title: "Project", disableSorting: false },
  {
    id: "startDate",
    title: "Start Date",
    disableSorting: true,
  },
  { id: "endDate", title: "End Date", disableSorting: true },
  {
    id: "comment",
    title: "Comment",
    disableSorting: true,
  },
];

//Date Util Functions
// Function to get the first day of the current month
const getFirstDayOfMonth = () => {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), 2)
    .toISOString()
    .split("T")[0];
};
// Function to get the current date
const getCurrentDate = () => {
  return new Date().toISOString().split("T")[0];
};
// Function to get date 90 days from today
const getDate90DaysFromNow = () => {
  const today = new Date();
  const futureDate = new Date();
  futureDate.setDate(today.getDate() + 90);
  return futureDate.toISOString().split("T")[0];
};

let init = true;

export default function EmployeeLeavePlans() {
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState(getDate90DaysFromNow());

  let empData = JSON.parse(sessionStorage.getItem("getUser"));
  useEffect(() => {
    getLeavePlans(empData?.strEmpID ?? "0", startDate, endDate)
      .then((response) => {
        setRecords(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.message === "Request failed with status code 401") {
          // Trigger global session timeout popup
          window.dispatchEvent(new Event("sessionExpired"));
        } else {
            alert(error.message);
        }
      });
  }, [empData?.strEmpID ?? "0"]);

  //URL Protection Measure
  //import { useHistory } from "react-router-dom";
  const history = useHistory();
  useEffect(() => {
    if (empData.strRoleName === "User") {
      history.push("/");
      alert("Warning: un-authorized access!");
    }
  }, []);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
  } = CustomTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.strFirstName.toLowerCase().includes(target.value.toLowerCase())
          );
      },
    });
  };

  const handleDateFilter = () => {
    // setFilterFn({
    //   fn: (items) => {
    //     if (startDate === "" && endDate === "") return items;
    //     return items.filter(
    //       (x) =>
    //         new Date(x.dtStartDate) >= new Date(startDate) &&
    //         new Date(x.dtEndDate) <= new Date(endDate)
    //     );
    //   },
    // });
    if (endDate !== "") {
      getLeavePlans(empData?.strEmpID ?? "0", startDate, endDate)
        .then((response) => {
          setRecords(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          if (error.message === "Request failed with status code 401") {
            // Trigger global session timeout popup
            window.dispatchEvent(new Event("sessionExpired"));
          } else {
            alert(error.message);
          }
        });
    } else {
      setIsLoading(false);
    }
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    // setEndDate("");
    setIsLoading(true);
  };
  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setIsLoading(true);
  };

  useEffect(() => {
    if (init === true) {
      init = false;
      return;
    }
    const dateY = new Date(endDate);
    const dateX = new Date(startDate);

    if (dateY >= dateX && endDate !== "" && startDate !== "") {
      handleDateFilter();
    } else {
      setIsLoading(false);
    }
  }, [endDate, startDate]);

  const handleDownload = (e) => {
    let table = document.getElementById("table-plans");
    TableToExcel.convert(table, {
      name: `employee_leavePlans.xlsx`, // fileName
      sheet: {
        name: "Sheet 1", // sheetName
      },
    });
  };

  const DateConvert = (inputDate) => {
    //console.log(inputDate);
    let date = new Date(inputDate);
    return new Intl.DateTimeFormat("en-IN").format(date);
  };

  return (
    <div className="container-fluid">
      <div className={isLoading === true ? "overlay" : "hideLoading"}>
        <div className="loader">Loading...</div>
      </div>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Leave Management</Breadcrumb.Item>
        <Breadcrumb.Item active>Employee Leave Plans</Breadcrumb.Item>
      </Breadcrumb>
      <div className="card">
        <div className="card-header bg-primary text-white">
          Employee Leave Plans
        </div>

        <div className="card-body ">
          <div className="d-flex justify-content-between">
            <div className="row row-cols-lg-auto g-3">
              <label htmlFor="fromDate" className="ml-3 p-1 text-muted">
                From Date:
              </label>
              <div className="form-group">
                <input
                  type="date"
                  id="fromDate"
                  name="fromDate"
                  value={startDate}
                  max={endDate}
                  onChange={handleStartDateChange}
                  className="form-control ml-1"
                />
              </div>
              <label htmlFor="toDate" className="ml-4 p-1 text-muted">
                To Date:
              </label>
              <div className="form-group">
                <input
                  type="date"
                  id="toDate"
                  name="toDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  min={startDate}
                  className="form-control ml-1"
                />
              </div>
            </div>
            <div className="col-md-3 ml-auto">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="search"
                  id="txtSearch"
                  onChange={handleSearch}></input>
              </div>
            </div>
            <div className="">
              <div className="form-group">
                <button
                  className=""
                  placeholder="download"
                  id="download"
                  title="Download as Excel Sheet"
                  onClick={handleDownload}>
                  <img
                    id="ExcelImage"
                    src={downloadBtn}
                    alt="exl_download_img"
                  />
                </button>
              </div>
            </div>
          </div>
          <TblContainer id="plans">
            <TblHead />
            <TableBody>
              {/* use recordsAfterPagingAndSorting if pagination  requried */}
              {recordsAfterPagingAndSorting().map((item) => (
                <TableRow key={item.empId}>
                  <TableCell style={{ textAlign: "center" }}>
                    {item.empId}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {item.strFirstName}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {item.Project}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {DateConvert(item.dtStartDate)}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {DateConvert(item.dtEndDate)}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {item.strReason}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </div>
    </div>
  );
}
